// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__VELl2","requiredAsterisk":"Info_requiredAsterisk__2yhFf"};